import { helpers, required, requiredIf, email } from "@vuelidate/validators";
import {UseCourierStore} from "@/stores/courierStore";
import {useI18n} from "vue-i18n";



export const useCouriersValidationGR = () => {
    const courierStore = UseCourierStore();
    const {t} = useI18n()
    const rules = {
        selectedCourier: { required: helpers.withMessage(t('courier.selectCourier'), required) },
        selectedAddress: {
            required: helpers.withMessage(
                t('courier.selectAddress'),
                requiredIf(() => courierStore.selectedCourier === 'ACS GR')
            ),
        },
        selectedAddressCC: {
            required: helpers.withMessage(
                t('courier.selectAddress'),
            requiredIf(() => courierStore.selectedCourier === 'Courier Center')
            ),
        },
        formData: {
            name: {
                required: helpers.withMessage(t('courier.enterName'), requiredIf(function () {
                    return ((courierStore.selectedAddress === 'new-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'new-addressCC' && courierStore.selectedCourier === 'Courier Center'));
                })),
                alpha: helpers.withMessage(
                    t('courier.invalidName'),
                    function (value) {
                        if ((courierStore.selectedAddress === 'new-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'new-addressCC' && courierStore.selectedCourier === 'Courier Center')) {
                            return /^[\p{L} ]+$/u.test(value);
                        }
                        return true; // If condition is false, skip validation
                    }
                ),
            },
            phone: {
                required: helpers.withMessage(t('courier.enterPhone'), requiredIf(function () {
                    return ((courierStore.selectedAddress === 'new-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'new-addressCC' && courierStore.selectedCourier === 'Courier Center'));
                }))
            },
            email: {
                required: helpers.withMessage(
                    t('courier.enterEmail'),
                    requiredIf(function () {
                        return ((courierStore.selectedAddress === 'new-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'new-addressCC' && courierStore.selectedCourier === 'Courier Center'));
                    })
                ),
                email: helpers.withMessage(
                    t('courier.invalidEmail'),
                    function (value) {
                        return ((courierStore.selectedAddress === 'new-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'new-addressCC' && courierStore.selectedCourier === 'Courier Center'))
                            ? email.$validator(value) // Apply email validation only if the condition is true
                            : true; // Otherwise, skip validation
                    }
                ),
            },
            address: {
                required: helpers.withMessage(t('courier.enterAddress'), requiredIf(function () {
                    return ((courierStore.selectedAddress === 'new-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'new-addressCC' && courierStore.selectedCourier === 'Courier Center'));
                }))
            },
            city: {
                required: helpers.withMessage(t('courier.enterCity'), requiredIf(function () {
                    return ((courierStore.selectedAddress === 'new-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'new-addressCC' && courierStore.selectedCourier === 'Courier Center'));
                })),
                alpha: helpers.withMessage(
                    t('courier.invalidCity'),
                    function (value) {
                        if ((courierStore.selectedAddress === 'new-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'new-addressCC' && courierStore.selectedCourier === 'Courier Center')) {
                            return /^[\p{L} ]+$/u.test(value);
                        }
                        return true; // If condition is false, skip validation
                    }
                ),
            },
            zip: {
                required: helpers.withMessage(t('courier.enterZip'), requiredIf(function () {
                    return ((courierStore.selectedAddress === 'new-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'new-addressCC' && courierStore.selectedCourier === 'Courier Center'));
                }))
            },
        },

        formData_backup: {
            name: {
                required: helpers.withMessage(t('courier.enterName'), requiredIf(function () {
                    return ((courierStore.selectedAddress === 'edited-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'edited-addressCC' && courierStore.selectedCourier === 'Courier Center'));
                })),
                alpha: helpers.withMessage(
                    t('courier.invalidName'),
                    function (value) {
                        if ((courierStore.selectedAddress === 'edited-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'edited-addressCC' && courierStore.selectedCourier === 'Courier Center')) {
                            return /^[\p{L} ]+$/u.test(value);
                        }
                        return true; // If condition is false, skip validation
                    }
                ),
            },
            phone: {
                required: helpers.withMessage(t('courier.enterPhone'), requiredIf(function () {
                    return ((courierStore.selectedAddress === 'edited-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'edited-addressCC' && courierStore.selectedCourier === 'Courier Center'));
                }))
            },
            email: {
                required: helpers.withMessage(
                    t('courier.enterEmail'),
                    requiredIf(function () {
                        return ((courierStore.selectedAddress === 'edited-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'edited-addressCC' && courierStore.selectedCourier === 'Courier Center'));
                    })
                ),
                email: helpers.withMessage(
                    t('courier.invalidEmail'),
                    function (value) {
                        return ((courierStore.selectedAddress === 'edited-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'edited-addressCC' && courierStore.selectedCourier === 'Courier Center'))
                            ? email.$validator(value) // Apply email validation only if the condition is true
                            : true; // Otherwise, skip validation
                    }
                ),
            },
            address: {
                required: helpers.withMessage(t('courier.enterAddress'), requiredIf(function () {
                    return ((courierStore.selectedAddress === 'edited-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'edited-addressCC' && courierStore.selectedCourier === 'Courier Center'));
                }))
            },
            city: {
                required: helpers.withMessage(t('courier.enterCity'), requiredIf(function () {
                    return ((courierStore.selectedAddress === 'edited-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'edited-addressCC' && courierStore.selectedCourier === 'Courier Center'));
                })),
                alpha: helpers.withMessage(
                    t('courier.invalidCity'),
                    function (value) {
                        if ((courierStore.selectedAddress === 'edited-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'edited-addressCC' && courierStore.selectedCourier === 'Courier Center')) {
                            return /^[\p{L} ]+$/u.test(value);
                        }
                        return true; // If condition is false, skip validation
                    }
                ),
            },
            zip: {
                required: helpers.withMessage(t('courier.enterZip'), requiredIf(function () {
                    return ((courierStore.selectedAddress === 'edited-address' && courierStore.selectedCourier === 'ACS GR') || (courierStore.selectedAddressCC === 'edited-addressCC' && courierStore.selectedCourier === 'Courier Center'));
                }))
            },
        },

    };
    return { rules };
};